import './plugin';

let { View } = window.App;

View.addHook( 'init', v => {
    v.$( '.js-expanding-grid' ).expandingGrid();
} )



// WEBPACK FOOTER //
// ./resources/assets/js/modules/expanding-grid/index.js